import React from "react";
import { Typography } from "@mui/material";
import TranslationContent from "../../../../Translations/TranslationContent";


const InvalidBoolean = () => {
  return <Typography sx={{color: "black"}} variant="body2"><TranslationContent contentID="invalidBooleanDesc" /></Typography>
}

export default InvalidBoolean;